import { getGameStoreFeedsStats } from '@op/services';
import { useEffect, useState } from 'react';

export default function useRegionReviews({ gameInfo, keepParams }: any) {
  const [reviewsResultMap, setReviewsResultMap] = useState<any>({});
  const getReviews = () => {
    const { start_time, end_time, date_type } = keepParams;
    getGameStoreFeedsStats({
      ...gameInfo,
      start_time,
      end_time,
      date_type,
      channels: ['google play', 'app store'],
    }).then((data: any) => {
      const resultMap: any = {};
      (data?.list || []).forEach(({ channel, region, mentions }: any) => {
        if (region === 'global') return;
        if (region === '') region = 'global';
        const value = resultMap[region];
        if (!value) resultMap[region] = {};
        resultMap[region] = {
          ...value,
          [channel + '-lifetime_reviews']: mentions,
        };
      });
      setReviewsResultMap(resultMap);
    });
  };

  useEffect(() => {
    if (gameInfo && keepParams?.start_time) {
      getReviews();
    }
  }, [gameInfo, keepParams]);

  return { reviewsResultMap };
}
